import { useModalContext } from '@app/components/various/Modal/ModalContext';
import { cn } from '@app/utils/cn';
import { useIsAtBottom } from '@app/utils/hooks';
import React from 'react';

export const StickyModalFooter = ({ children }: React.WithChildren) => {
  const { contentRef } = useModalContext();
  const isAtBottom = useIsAtBottom(contentRef);

  return (
    <div className="sticky bottom-0 mt-7 bg-white pb-1">
      <div
        className={cn('-mx-6 mb-3 h-[1px] w-[calc(100%+3rem)] border-t border-neutral-90 opacity-100 transition-opacity duration-150', {
          'opacity-0': isAtBottom,
        })}
      />
      <span className="absolute top-[1px] -mx-6 h-[3.5rem] w-[calc(100%+3rem)] bg-white px-[1px]" />
      <div className="relative">{children}</div>
    </div>
  );
};
